import React, { useState } from 'react';
import BlogLink from '../../BlogLink';
import { Container, Input, Label, Result, Text } from '../../styles';
import Base from '../Base';
import ListTable from './ListTable';



function FestaBody() {


  // 変更する
  // ---------------------------------------------
  // 2022.4.28
  // 921,4605(sum,cost)
  const getRate = [0.0010857763300760044, 0.01737242128121607, 0.09229098805646037, 0.28773072747014117, 0.30618892508143325, 0.2953311617806732]; //獲得確率

  const ticketPerEngrgyInit = 6; //チケット/1エナジー

  // 表示設定
  // ---------------------------------------------
  const [digits, setDigits] = useState(0);
  // const digits = 0;
  const [energy, setEnergy] = useState(250);
  const [ticketPerEngrgy, setTicketPerEngrgy] = useState(ticketPerEngrgyInit);
  // ---------------------------------------------

  // 確認する
  // 初期設定
  // ---------------------------------------------
  const needTicket = 5;
  const itemPertimes = [1, 1, 1, 1, 100, 100];
  const timesPerEngrgy = ticketPerEngrgy / needTicket; //1エナジーあたり何回抽選できるか

  // ---------------------------------------------

  // 消費エナジー推定
  // const consumedEnergy = times * needMedal / medalPerEngrgy

  // const getItem = [];
  // const getItemPerTime = [];
  const getRatePerEnergy = [];

  //   集計
  for (let i = 0; i < getRate.length; i++) {
    // getItem[i] = getTimes[i] * itemPertimes[i]; //手に入ったアイテム総数
    // getItemPerTime[i] = getItem[i] / times; 
    // getRatePerEnergy[i] = getItemPerTime[i] * timesPerEngrgy
    // getRatePerEnergy[i] = getItem[i] / consumedEnergy
    // getRatePerEnergy[i] = getRate[i] / timesPerEngrgy
    getRatePerEnergy[i] = getRate[i] * timesPerEngrgy //1エナジーあたりi等が何回当たるか
  }

  //   実質消費エナジー
  const returnRate = getRatePerEnergy[3] * itemPertimes[3]
  const realEnergy = 1 - (getRatePerEnergy[3] * itemPertimes[3]);

  //   消費エナジー変更
  const handleEnergyChange = (event) => {
    setEnergy(event.target.value);
  };

  //   桁数変更
  const handleDigitsChange = (event) => {
    if (event.target.value >= 0) {
      var dig = event.target.value;
    } else {
      var dig = 0;
    }
    setDigits(dig);
  };


  const calculateItem = () => {
    const getItemPerRealEnergy = [];
    const getItemExpected = [];
    for (let i = 0; i < getRate.length; i++) {
      getItemPerRealEnergy[i] = getRatePerEnergy[i] / realEnergy; //後で修正
      // getItemPerRealEnergy[i] = getItem[i] / realEnergy;
      getItemExpected[i] = ((getItemPerRealEnergy[i] * energy) * itemPertimes[i]).toFixed(digits);
      // getItemExpected[i] = (realGetRate[i] * energy).toFixed(digits);
    }

    return getItemExpected
  }

  const getItemExpected = calculateItem()

  const itemExpectedList = [
    { name: 'S契約書', result: getItemExpected[0] },
    { name: 'A契約書', result: getItemExpected[1] },
    { name: 'B契約書', result: getItemExpected[2] },
    { name: 'スカウトP', result: getItemExpected[4] },
    { name: 'コイン', result: getItemExpected[5] },
  ];

  return (
    <>
      <Base body={
        <Container>
          <h1>プロスピフェスタ</h1>
          <Label>
            <Text>消費エナジー：</Text>
            <Input type="number" value={energy} onChange={handleEnergyChange} />
          </Label>
          {/* <label>
        桁数：
        <input type="number" value={digits} onChange={handleDigitsChange} />
      </label> */}

          <div>
            <h2>計算結果</h2>
            <ListTable list={itemExpectedList} />
          </div>
          <Result>
            <Text>エナジー還元率:{returnRate.toFixed(3)}</Text>
          </Result>
          <div>
            <p>{energy}エナジー消費した時に得られるアイテム数の期待値がResultに表示されます。</p>
          </div>
          <BlogLink link={"https://www.sakusaku27.com/27/"} />
        </Container>
      } title="フェスタ" />
    </>
  );
}

export default FestaBody;
